// extracted by mini-css-extract-plugin
export default {"endPipe":"AppointmentFilters_endPipe__6R2Hg"};